import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

// Helper untuk header JSON
const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`, 
  'Content-Type': 'application/json'
});

// Helper khusus untuk Upload File (Multipart)
const getAuthMultipartHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`,
  'Content-Type': 'multipart/form-data'
});

// Endpoint sesuai dengan Route group di Golang Handler tadi
const ENDPOINT = "/transaksi-pembelian-tanah"; 
const ENDPOINTPengajuan = "/transaksi-pembelian-tanah/pengajuan"; 
const ENDPOINTSisaHutang = "/transaksi-pembelian-tanah/hutang-tanah"; 


/**
 * FETCH DATA TRANSAKSI
 * Mendukung filter search, lokasi, pemilik, dan pagination
 */
export const fetchTransaksiPembelian = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams({});
    
    // Cek apakah pagination dimatikan
    if (params.disable_pagination) {
      urlParams.append('disable_pagination', true);
    } else {
      // Jika tidak disable, baru kirim parameter page & per_page
      urlParams.append('page', params.page || 1);
      urlParams.append('per_page', params.per_page || 10);
    }
    
    // Filter Search
    if (params.search) urlParams.append('search', params.search);

    // Filter Relasi
    if (params.id_lokasi) urlParams.append('id_lokasi', params.id_lokasi);
    if (params.id_pemilik) urlParams.append('id_pemilik', params.id_pemilik);
    
    const response = await axios.get(`${BASE_URL_BE}${ENDPOINT}?${urlParams.toString()}`, {
      headers: getAuthHeaders()
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching transaksi:", error);
    throw error;
  }
};


export const fetchTransaksiPembelianPengajuan = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams({});
    
    // Cek apakah pagination dimatikan
    if (params.disable_pagination) {
      urlParams.append('disable_pagination', true);
    } else {
      urlParams.append('page', params.page || 1);
      urlParams.append('per_page', params.per_page || 10);
    }
    
    if (params.search) urlParams.append('search', params.search);
    if (params.id_lokasi) urlParams.append('id_lokasi', params.id_lokasi);
    if (params.id_pemilik) urlParams.append('id_pemilik', params.id_pemilik);
    
    const response = await axios.get(`${BASE_URL_BE}${ENDPOINTPengajuan}?${urlParams.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching transaksi:", error);
    throw error;
  }
};

export const fetchTransaksiSisaHutang = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams({});
    
    // Cek apakah pagination dimatikan
    if (params.disable_pagination) {
      urlParams.append('disable_pagination', true);
    } else {
      urlParams.append('page', params.page || 1);
      urlParams.append('per_page', params.per_page || 10);
    }
    
    if (params.search) urlParams.append('search', params.search);
    if (params.id_lokasi) urlParams.append('id_lokasi', params.id_lokasi);
    if (params.id_pemilik) urlParams.append('id_pemilik', params.id_pemilik);
    
    const response = await axios.get(`${BASE_URL_BE}${ENDPOINTSisaHutang}?${urlParams.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching transaksi:", error);
    throw error;
  }
};
/**
 * CREATE TRANSAKSI
 * Menggunakan FormData karena menyertakan Upload File
 */
export const createTransaksiPembelian = async (formData) => {
  try {
    // Pastikan data yang dikirim adalah object FormData dari frontend
    const response = await axios.post(`${BASE_URL_BE}${ENDPOINT}`, formData, {
      headers: getAuthMultipartHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error creating transaksi:", error);
    throw error;
  }
};

/**
 * UPDATE TRANSAKSI
 * Menggunakan FormData jika ingin update file hasil ukur
 */
export const updateTransaksiPembelian = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${ENDPOINT}/${id}`, formData, {
      headers: getAuthMultipartHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error updating transaksi:", error);
    throw error;
  }
};

/**
 * DELETE TRANSAKSI
 */
export const deleteTransaksiPembelian = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}${ENDPOINT}/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting transaksi:", error);
    throw error;
  }
};

/**
 * GET DETAIL TRANSAKSI
 */
export const getTransaksiByID = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${ENDPOINT}/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching detail transaksi:", error);
    throw error;
  }
};